namespace TabAurous.Scheme {
    export namespace SchemeSelectService {
        export const baseUrl = 'Scheme/SchemeSelect';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SchemeEnrollmentRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Scheme/SchemeSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>SchemeSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
